/**
 * Service de tarification équipe : le responsable d'équipe (index le plus bas) paie le tarif complet.
 */
class TeamPricingService {
    _buildGroupKey(id_course, equipe_name) {
        return `${id_course}|${equipe_name || ''}`;
    }

    /**
     * Construit une map des responsables d'équipe par course + nom d'équipe.
     * @param {Array} inscriptions
     * @returns {Map<string, number>} clé → index du responsable
     */
    buildLeaderMap(inscriptions) {
        const leaderMap = new Map();
        if (!inscriptions || !Array.isArray(inscriptions)) {
            return leaderMap;
        }

        for (let i = 0; i < inscriptions.length; i++) {
            const inscription = inscriptions[i];
            if (!inscription?.list_courses?.list) continue;

            const equipe_name = inscription.get_equipe_name ? inscription.get_equipe_name() : (inscription.coureur?.equipe_name || '');

            for (let j = 0; j < inscription.list_courses.list.length; j++) {
                const course = inscription.list_courses.list[j];
                if (!course.selected || !course.is_equipe_course?.()) continue;

                const key = this._buildGroupKey(course.id, equipe_name);
                const currentLeader = leaderMap.get(key);
                if (currentLeader === undefined || i < currentLeader) {
                    leaderMap.set(key, i);
                }
            }
        }

        return leaderMap;
    }

    isTeamPriceLeader(inscriptionIndex, id_course, equipe_name, leaderMap) {
        const key = this._buildGroupKey(id_course, equipe_name);
        const leaderIndex = leaderMap.get(key);
        if (leaderIndex === undefined) {
            return true;
        }
        return leaderIndex === inscriptionIndex;
    }

    /**
     * Contexte de tarification pour une inscription / course.
     * @param {number} inscriptionIndex
     * @param {Object} course
     * @param {string} equipe_name
     * @param {Map} leaderMap
     * @returns {{ is_team_member: boolean, is_leader: boolean }}
     */
    getPricingContext(inscriptionIndex, course, equipe_name, leaderMap) {
        if (!course?.is_equipe_course?.()) {
            return { is_team_member: false, is_leader: true };
        }

        return {
            is_team_member: true,
            is_leader: this.isTeamPriceLeader(inscriptionIndex, course.id, equipe_name, leaderMap),
        };
    }

    /**
     * Applique le prix 0 aux membres non-responsables si le tarif est un tarif équipe.
     * @param {Object} cart
     * @param {Object} course
     * @param {Object} pricingContext
     */
    applyTeamPriceToCart(cart, course, pricingContext) {
        if (!cart?.id_tarif || !course?.tarifs?.list) return;

        const tarif = course.tarifs.list.find((t) => t.id == cart.id_tarif);
        if (!tarif?.is_team_price?.()) return;

        cart.is_team_price = true;

        if (pricingContext?.is_team_member && !pricingContext?.is_leader) {
            cart.prix = 0;
            cart.prix_regulier = 0;
        }
    }
}

export default new TeamPricingService();
